import { SET_HAS_EXPERIENCE } from '../actions/hasExperienceDataActions';

let initialState = false;

const hasExperienceDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_EXPERIENCE:
            return action.payload.value
        default:
            return state;
    }
}

export default hasExperienceDataReducer;